const togglePopupDisplay = (displayStyle) => {
    const popup = document.getElementById('popup');
    popup.style.display = displayStyle;
};

const handleDetailsClick = (event) => {
    event.preventDefault();
    const detail = event.currentTarget;
    detail.toggleAttribute('open');
    
    const content = detail.querySelector('.content');
    content.style.maxHeight = detail.open ? `${content.scrollHeight}px` : '0';
};

document.querySelector('.faq-password-link').addEventListener('click', () => {
    togglePopupDisplay('block');
});

document.querySelector('.close').addEventListener('click', () => {
    togglePopupDisplay('none');
});

window.addEventListener('click', (event) => {
    const popup = document.getElementById('popup');
    if (event.target === popup) {
        togglePopupDisplay('none');
    }
});

document.querySelectorAll('.details-faq-info').forEach((detail) => {
    detail.addEventListener('click', handleDetailsClick);
});
